import {BusinessActivity} from "@/store/api/businessActivityApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface BusinessActivityState {
    businessActivities: BusinessActivity[];
}

const initialState: BusinessActivityState = {
    businessActivities: [],
}

const businessActivitySlice = createSlice({
    name: "businessActivities",
    initialState,
    reducers: {
        setBusinessActivities: (state, action: PayloadAction<BusinessActivity[]>) => {
            state.businessActivities = action.payload;
        },
        clearBusinessActivities: (state) => {
            state.businessActivities = [];
        }
    }
})


export const { setBusinessActivities, clearBusinessActivities } = businessActivitySlice.actions;
export default businessActivitySlice.reducer;
